import { render, staticRenderFns } from "./migrate-modal.vue?vue&type=template&id=b1855394&scoped=true"
import script from "./migrate-modal.vue?vue&type=script&lang=js"
export * from "./migrate-modal.vue?vue&type=script&lang=js"
import style0 from "./migrate-modal.vue?vue&type=style&index=0&id=b1855394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1855394",
  null
  
)

export default component.exports